import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';
import styles from './lariferreiraestetica_procedimentos.module.scss';
import MaquiagemSocial1 from './src/procedimentos/maquiagem-social-1.png';
import MaquiagemSocial2 from './src/procedimentos/maquiagem-social-2.png';
import MaquiagemSocial3 from './src/procedimentos/maquiagem-social-3.png';
import MaquiagemDebutante1 from './src/procedimentos/maquiagem-debutante-1.png';
import MaquiagemDebutante2 from './src/procedimentos/maquiagem-debutante-2.png';
import MaquiagemDebutante3 from './src/procedimentos/maquiagem-debutante-3.png';
import Babyliss from './src/procedimentos/babyliss.png';
import LimpezaDePele from './src/procedimentos/limpeza-pele-1.png';
import Drenagem from './src/procedimentos/drenagem-1.png';
import Henna from './src/procedimentos/henna-1.png';
import Lash1 from './src/procedimentos/lash-1.png';
import Lash2 from './src/procedimentos/lash-2.png';

const WHATSAPP_NUMBER = '5517996550071';

type ProcedimentoItem = {
    id: string;
    nome: string;
    descricao: string;
    preco: string;
    imagens: string[];
};

type CategoriaProcedimentos = {
    id: string;
    titulo: string;
    itens: ProcedimentoItem[];
    pacotes?: ProcedimentoItem[];
};

const categorias: CategoriaProcedimentos[] = [
    {
        id: 'maquiagem',
        titulo: 'Maquiagem',
        itens: [
            {
                id: 'maquiagem-social',
                nome: 'Maquiagem social',
                descricao: 'Produção elegante e harmoniosa para eventos, trabalho ou ocasiões do dia a dia.',
                preco: 'R$ 160,00',
                imagens: [MaquiagemSocial1, MaquiagemSocial2, MaquiagemSocial3],
            },
            {
                id: 'maquiagem-noiva-civil',
                nome: 'Maquiagem noiva civil e debutante',
                descricao: 'Maquiagem especial para momentos marcantes, com acabamento duradouro e personalizado.',
                preco: 'R$ 200,00',
                imagens: [MaquiagemDebutante1, MaquiagemDebutante2, MaquiagemDebutante3],
            },
            {
                id: 'maquiagem-noiva-cerimonia',
                nome: 'Maquiagem noiva cerimônia',
                descricao: 'Maquiagem para a cerimônia de casamento, com produção à prova de emoção e acabamento impecável para fotos e vídeos.',
                preco: 'A combinar',
                imagens: [],
            },
            {
                id: 'babyliss',
                nome: 'Babyliss',
                descricao: 'Modelagem dos fios com babyliss para dar volume, definição e movimento ao visual.',
                preco: 'R$ 60,00',
                imagens: [Babyliss],
            },
        ],
    },
    {
        id: 'massagens',
        titulo: 'Massagens e Drenagem',
        itens: [
            {
                id: 'drenagem-linfatica',
                nome: 'Drenagem linfática',
                descricao: 'Técnica que estimula a circulação e auxilia na redução de inchaço e retenção de líquidos.',
                preco: 'R$ 85,00',
                imagens: [Drenagem],
            },
            {
                id: 'massagem-relaxante',
                nome: 'Massagem relaxante',
                descricao: 'Massagem corporal com manobras suaves para aliviar tensões e promover bem-estar.',
                preco: 'R$ 80,00',
                imagens: [],
            },
            {
                id: 'manta-termica',
                nome: 'Manta térmica',
                descricao: 'Terapia complementar com calor que relaxa os músculos e potencializa os tratamentos.',
                preco: 'R$ 40,00',
                imagens: [],
            },
            {
                id: 'ventosaterapia',
                nome: 'Ventosaterapia',
                descricao: 'Técnica com ventosas que melhora a circulação e auxilia na liberação de tensões musculares.',
                preco: 'R$ 50,00',
                imagens: [],
            },
            {
                id: 'ultrassom',
                nome: 'Ultrassom',
                descricao: 'Tratamento por área que utiliza ultrassom para auxiliar na quebra de gordura localizada.',
                preco: 'R$ 40,00 por área/sessão',
                imagens: [],
            },
        ],
        pacotes: [
            {
                id: 'pacote-drenagem-4',
                nome: '4 sessões de drenagem linfática',
                descricao: 'Pacote com 4 sessões de drenagem linfática com valor especial.',
                preco: 'R$ 250,00',
                imagens: [],
            },
            {
                id: 'pacote-drenagem-manta-4',
                nome: '4 sessões de drenagem com manta térmica',
                descricao: 'Pacote combinando drenagem linfática e manta térmica em 4 sessões.',
                preco: 'R$ 320,00',
                imagens: [],
            },
            {
                id: 'pacote-drenagem-manta-ultrassom-4',
                nome: '4 sessões de drenagem com manta e ultrassom',
                descricao: 'Pacote completo com drenagem, manta térmica e ultrassom em 4 sessões.',
                preco: 'R$ 380,00',
                imagens: [],
            },
            {
                id: 'pacote-massagem-relaxante-4',
                nome: '4 sessões de massagem relaxante',
                descricao: 'Pacote com 4 sessões de massagem relaxante com desconto.',
                preco: 'R$ 250,00',
                imagens: [],
            },
        ],
    },
    {
        id: 'estetica-facial',
        titulo: 'Estética Facial e Sobrancelhas',
        itens: [
            {
                id: 'limpeza-de-pele',
                nome: 'Limpeza de pele',
                descricao: 'Remove impurezas e células mortas, deixando a pele mais limpa, saudável e renovada.',
                preco: 'R$ 120,00',
                imagens: [LimpezaDePele],
            },
            {
                id: 'design-sobrancelha',
                nome: 'Design de sobrancelha',
                descricao: 'Modelagem personalizada dos fios para valorizar o rosto e realçar o olhar.',
                preco: 'R$ 30,00',
                imagens: [],
            },
            {
                id: 'design-henna',
                nome: 'Design com henna',
                descricao: 'Design de sobrancelha com henna para preenchimento natural e definição prolongada.',
                preco: 'R$ 40,00',
                imagens: [Henna],
            },
            {
                id: 'design-masculino',
                nome: 'Design masculino',
                descricao: 'Modelagem de sobrancelhas adaptada ao padrão masculino, com aparência natural.',
                preco: 'R$ 35,00',
                imagens: [],
            },
            {
                id: 'lash-lifting',
                nome: 'Lash lifting',
                descricao: 'Curva e define os cílios naturais, deixando o olhar mais aberto sem extensões.',
                preco: 'R$ 110,00',
                imagens: [Lash1, Lash2],
            },
        ],
    },
];

const getWhatsappUrl = (nome: string) => {
    const message = `Olá! Vim pela página de procedimentos da Larissa Ferreira e gostaria de informações sobre ${nome}.`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

interface CardProcedimentoProps {
    nome: string;
    descricao: string;
    preco: string;
    imagens: string[];
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({ nome, descricao, preco, imagens }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasImages = imagens.length > 0;
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    return (
        <article className={styles.card}>
            {hasImages && (
                <div className={styles.carouselContainer}>
                    <img src={imagens[currentIndex]} alt={nome} className={styles.carouselImage} />
                    {hasMultipleImages && (
                        <>
                            <button
                                type="button"
                                className={`${styles.carouselBtn} ${styles.prevBtn}`}
                                onClick={prevImage}
                                aria-label="Imagem anterior"
                            >
                                <FaChevronLeft />
                            </button>
                            <button
                                type="button"
                                className={`${styles.carouselBtn} ${styles.nextBtn}`}
                                onClick={nextImage}
                                aria-label="Próxima imagem"
                            >
                                <FaChevronRight />
                            </button>
                            <div className={styles.indicators}>
                                {imagens.map((_, idx) => (
                                    <span
                                        key={idx}
                                        role="button"
                                        tabIndex={0}
                                        className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setCurrentIndex(idx);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setCurrentIndex(idx);
                                            }
                                        }}
                                        aria-label={`Ir para imagem ${idx + 1}`}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}

            <div className={styles.cardBody}>
                <h3 className={styles.cardTitle}>{nome}</h3>
                <p className={styles.descricao}>{descricao}</p>
                <p className={styles.preco}>{preco}</p>
            </div>

            <a
                href={getWhatsappUrl(nome)}
                className={styles.whatsappBtn}
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaWhatsapp aria-hidden />
                <span>Agendar pelo WhatsApp</span>
            </a>
        </article>
    );
};

interface CategoriaSectionProps {
    titulo: string;
    itens: ProcedimentoItem[];
    pacotes?: ProcedimentoItem[];
}

const CategoriaSection: React.FC<CategoriaSectionProps> = ({ titulo, itens, pacotes }) => (
    <section className={styles.categoria}>
        <h2 className={styles.categoriaTitle}>{titulo}</h2>

        <div className={styles.categoriaLista}>
            {itens.map((item) => (
                <CardProcedimento
                    key={item.id}
                    nome={item.nome}
                    descricao={item.descricao}
                    preco={item.preco}
                    imagens={item.imagens}
                />
            ))}
        </div>

        {pacotes && pacotes.length > 0 && (
            <div className={styles.pacotes}>
                <h3 className={styles.pacotesTitle}>Pacotes de massagem</h3>
                <div className={styles.pacotesLista}>
                    {pacotes.map((item) => (
                        <article key={item.id} className={styles.pacoteItem}>
                            <div className={styles.pacoteInfo}>
                                <p className={styles.pacoteNome}>{item.nome}</p>
                                <p className={styles.pacoteDescricao}>{item.descricao}</p>
                                <p className={styles.pacotePreco}>{item.preco}</p>
                            </div>
                            <a
                                href={getWhatsappUrl(item.nome)}
                                className={styles.pacoteBtn}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Agendar ${item.nome} pelo WhatsApp`}
                            >
                                <FaWhatsapp aria-hidden />
                            </a>
                        </article>
                    ))}
                </div>
            </div>
        )}
    </section>
);

const Lariferreiraestetica_procedimentos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.lariferreiraestetica_procedimentos}>
            <div className={styles.header}>
                <Link
                    to="/lariferreiraestetica"
                    state={{ skipLoader: true }}
                    className={styles.backButton}
                    aria-label="Voltar ao cartão digital"
                >
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.pageTitle}>Procedimentos</h1>
            </div>

            <p className={styles.pageSubtitle}>
                Conheça os serviços da Larissa Ferreira e agende diretamente pelo WhatsApp.
            </p>

            <div className={styles.lista}>
                {categorias.map((categoria) => (
                    <CategoriaSection
                        key={categoria.id}
                        titulo={categoria.titulo}
                        itens={categoria.itens}
                        pacotes={categoria.pacotes}
                    />
                ))}
            </div>
        </div>
    );
};

export default Lariferreiraestetica_procedimentos;
